import { useEffect, useState } from "react";
import api from "../lib/api";
import { Button } from "../components/ui/button";

const TONE = { OK: "bg-emerald-50 text-emerald-700", INFO: "bg-slate-100 text-slate-700", WARNING: "bg-amber-50 text-amber-800", HIGH: "bg-red-50 text-red-700", CRITICAL: "bg-red-100 text-red-800" };

function CheckRow({ c }) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-start gap-2 py-3 border-b border-slate-100" data-testid={`health-check-${c.key}`}>
      <span className={`shrink-0 w-24 text-center text-xs font-semibold rounded px-2 py-1 ${TONE[c.status] || TONE.INFO}`}>{c.status}</span>
      <div className="min-w-0">
        <div className="text-sm font-medium text-slate-900">{c.label}</div>
        <div className="text-sm text-slate-600 break-words">{c.detail}</div>
        {c.owner_action && <div className="text-xs text-amber-800 mt-1">Action: {c.owner_action}</div>}
      </div>
    </div>
  );
}

export default function PlatformHealth() {
  const [d, setD] = useState(null);
  const [err, setErr] = useState("");
  const load = () => api.get("/platform-health").then((r) => { setD(r.data); setErr(""); }).catch((e) => setErr(e.response?.data?.detail || "Could not load health"));
  useEffect(() => { load(); }, []);
  return (
    <div className="max-w-4xl mx-auto p-4 sm:p-6" data-testid="platform-health-page">
      <div className="flex flex-wrap items-center justify-between gap-3 mb-4">
        <div>
          <h1 className="text-2xl font-semibold text-slate-900">Platform health</h1>
          <p className="text-sm text-slate-500">In-app failure alerts for admins · {d?.email_alerts || ""}</p>
        </div>
        <Button variant="outline" onClick={load} data-testid="platform-health-refresh">Re-check now</Button>
      </div>
      {err && <div className="text-sm text-red-700 mb-3" data-testid="platform-health-error">{err}</div>}
      {d && (
        <>
          <div className="text-xs text-slate-500 mb-2" data-testid="platform-health-worst">Overall: {d.worst} · checked {String(d.at).slice(0, 16).replace("T", " ")} UTC · open alerts {d.open_alerts?.length || 0}</div>
          <div className="bg-white border border-slate-200 rounded-md px-4">{d.checks.map((c) => <CheckRow key={c.key} c={c} />)}</div>
        </>
      )}
    </div>
  );
}
